import FadeUp from "./FadeUp";

const months = [
    {
        num: "01",
        month: "Month 1",
        label: "Foundation",
        color: "bg-[#0A0A0A] text-white",
        items: [
            "Infrastructure build",
            "In-depth research on competitors and niche",
            "Sourcing creators",
            "Campaigns going live",
            "Sourcing relevant YouTubers",
        ],
    },
    {
        num: "02",
        month: "Month 2",
        label: "Activation",
        color: "bg-white text-[#0A0A0A] border border-black/[0.08]",
        items: [
            "Creator onboarding at scale",
            "Content briefs",
            "Nurturing flows set up",
            "Affiliate recruitment ramp",
            "Initiating UGC and whitelisting rights negotiation",
            "First UGC library live",
            "Expanded YouTube partnerships",
        ],
    },
    {
        num: "03",
        month: "Month 3",
        label: "Scale & Handoff",
        color: "bg-[#C6F432] text-[#0A0A0A]",
        items: [
            "Continued campaign running, feeding the system weekly with new creators",
            "Identifying top-performers and continuing promotion with them",
            "SOPs documented end-to-end",
            "Team training and shadowing",
            "Optional ongoing management",
        ],
    },
];

export const HowWeWork = () => (
    <section
        id="how-we-work"
        data-testid="how-we-work-section"
        className="py-24 md:py-32 bg-[#FAFAFA] border-y border-black/[0.06]"
    >
        <div className="container-page">
            <div className="max-w-3xl">
                <FadeUp>
                    <p className="text-xs font-bold tracking-[0.22em] uppercase text-gray-500">
                        How we work together
                    </p>
                </FadeUp>
                <FadeUp delay={0.05}>
                    <h2
                        data-testid="how-we-work-heading"
                        className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.3] text-[#0A0A0A] text-balance"
                    >
                        A three-month build, then it's yours.
                    </h2>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <p className="mt-5 text-[15.5px] md:text-base text-gray-600 leading-relaxed max-w-2xl">
                        Every month has a clear outcome. By month three, your team runs it without me.
                    </p>
                </FadeUp>
            </div>

            <div className="mt-14 relative">
                <div className="hidden md:block absolute top-6 left-0 right-0 h-[2px] bg-black/[0.08]" />
                <div className="grid md:grid-cols-3 gap-6 md:gap-6 relative">
                    {months.map((m, i) => (
                        <FadeUp key={i} delay={0.05 + i * 0.08}>
                            <div
                                data-testid={`month-card-${i}`}
                                className="relative flex flex-col h-full"
                            >
                                <div className="hidden md:flex absolute -top-1 left-6 h-[14px] w-[14px] rounded-full bg-white border-[3px] border-[#0A0A0A]" />
                                <div className="mt-0 md:mt-8 rounded-2xl border border-black/[0.08] bg-white p-6 md:p-7 h-full">
                                    <div className="flex items-center gap-3">
                                        <span
                                            className={`inline-flex items-center justify-center h-9 min-w-9 px-2.5 rounded-full text-[13px] font-bold tracking-tight ${m.color}`}
                                        >
                                            {m.num}
                                        </span>
                                        <div>
                                            <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-gray-500">
                                                {m.month}
                                            </div>
                                            <div className="font-display font-bold text-[19px] md:text-xl tracking-tight text-[#0A0A0A] leading-[1.3]">
                                                {m.label}
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="mt-6 space-y-2.5">
                                        {m.items.map((it, j) => (
                                            <li
                                                key={j}
                                                className="flex items-start gap-2.5 text-[14.5px] text-gray-700 leading-[1.65]"
                                            >
                                                <span className="mt-2 flex-none h-1.5 w-1.5 rounded-full bg-[#0A0A0A]" />
                                                {it}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default HowWeWork;
